import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  // Initialise the theme and set to the default purple theme
  private themeSelected: BehaviorSubject<any> = new BehaviorSubject<any>({});
  themes$: BehaviorSubject<any>;
  public themeSelected$ = this.themeSelected.asObservable();

  constructor(
    private http: HttpClient
  ) {
    this.themes$ = new BehaviorSubject([]);
  }


  getThemes() {
    this.http.get("assets/themelist.json").subscribe(
      (response: any) => {
        this.themes$.next(response);

        // get the theme from the cookie, if not set then set default
        let theme = this.getCookieTheme()
        if (this.getCookieTheme() == "") {
          this.setSelectedThemeByName("dxc-light-theme");
        } else {
          this.setSelectedThemeByName(theme);
        }

      }, (error: any) => {
        console.log('unable to get menus');
      }
    )
  }

  getSelectedTheme() {
    return this.themeSelected$;
  }

  setSelectedTheme(themeToSet): void {
    this.themeSelected.next(themeToSet);
    this.setCookieTheme(themeToSet["value"]);
  }

  setSelectedThemeByName(themeName: string): void {

    this.themes$.getValue().forEach(x => {
      if (x.value == themeName) {
        this.setCookieTheme(themeName);
        this.themeSelected.next(x);
      }
    });

    return;

  }

  getCookieTheme() {
    let name = "lndscp-theme"
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        let thm = c.substring(cookieName.length, c.length);
        if(thm=="dxc-blue-dark-theme") thm = "dxc-dark-theme";
        if(thm=="dxc-purple-theme") thm = "dxc-light-theme";

        return thm;
      }
    }
    return "";

  }

  setCookieTheme(value) {
    let d: Date = new Date();
    let expireDays = 365;
    let name = "lndscp-theme"
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/;SameSite=Strict`;
  }

}
